function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.438 4.662C9.337 3.983 3.622 4.038 2.812 9.5c-.641 4.328 1.926 14.257 6.418 22.914 1.973 3.803 4.951 5.092 8.342 5.092",
  stroke: "#1FA956",
  strokeWidth: 4.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.999 4.363H9.57",
  stroke: "#1FA956",
  strokeWidth: 8,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.844 37.312c0 3.623 2.018 9.987 11.73 7.623s4-11.429 12.002-13.143",
  stroke: "#1FA956",
  strokeWidth: 4.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M22.706 4.662c3.102-.679 8.817-.624 9.626 4.838.642 4.328-1.925 14.257-6.417 22.914-1.974 3.803-4.952 5.092-8.342 5.092",
  stroke: "#1FA956",
  strokeWidth: 4.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.142 4.363h3.428",
  stroke: "#1FA956",
  strokeWidth: 8,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 46.388,
  cy: 27.463,
  r: 7.174,
  fill: "#fff",
  stroke: "#1FA956",
  strokeWidth: 6.71
});

function SvgImgExperts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTciIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA1NyA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjQzODIgNC42NjIwOEM5LjMzNjYxIDMuOTgzMTMgMy42MjIwNyA0LjAzNzc2IDIuODEyNDEgOS40OTk1NkMyLjE3MDczIDEzLjgyODIgNC43Mzc1NiAyMy43NTczIDkuMjI5NTggMzIuNDEzOUMxMS4yMDMzIDM2LjIxNzUgMTQuMTgxMSAzNy41MDYxIDE3LjU3MiAzNy41MDYxIiBzdHJva2U9IiMxRkE5NTYiIHN0cm9rZS13aWR0aD0iNC41Ii8+CjxwYXRoIGQ9Ik0xMi45OTg5IDQuMzYzMjhDMTIuMzIzMSA0LjM2MzI4IDEwLjM5OTkgNC4zNjMyOCA5LjU3MDMxIDQuMzYzMjgiIHN0cm9rZT0iIzFGQTk1NiIgc3Ryb2tlLXdpZHRoPSI4IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTE3Ljg0MzggMzcuMzEyMUMxNy44NDM4IDQwLjkzNDggMTkuODYxNiA0Ny4yOTg5IDI5LjU3MzcgNDQuOTM0OEMzOS4yODU3IDQyLjU3MDggMzMuNTczNyAzMy41MDYzIDQxLjU3NTkgMzEuNzkyIiBzdHJva2U9IiMxRkE5NTYiIHN0cm9rZS13aWR0aD0iNC41Ii8+CjxwYXRoIGQ9Ik0yMi43MDYzIDQuNjYyMDhDMjUuODA3OSAzLjk4MzEzIDMxLjUyMjUgNC4wMzc3NiAzMi4zMzIxIDkuNDk5NTZDMzIuOTczOCAxMy44MjgyIDMwLjQwNyAyMy43NTczIDI1LjkxNSAzMi40MTM5QzIzLjk0MTIgMzYuMjE3NSAyMC45NjM0IDM3LjUwNjEgMTcuNTcyNSAzNy41MDYxIiBzdHJva2U9IiMxRkE5NTYiIHN0cm9rZS13aWR0aD0iNC41Ii8+CjxwYXRoIGQ9Ik0yMi4xNDE3IDQuMzYzMjhDMjIuODE3NiA0LjM2MzI4IDI0Ljc0MDcgNC4zNjMyOCAyNS41NzAzIDQuMzYzMjgiIHN0cm9rZT0iIzFGQTk1NiIgc3Ryb2tlLXdpZHRoPSI4IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPGNpcmNsZSBjeD0iNDYuMzg4IiBjeT0iMjcuNDYzMiIgcj0iNy4xNzM2NiIgZmlsbD0id2hpdGUiIHN0cm9rZT0iIzFGQTk1NiIgc3Ryb2tlLXdpZHRoPSI2LjcxIi8+Cjwvc3ZnPgo=";
export { SvgImgExperts as ReactComponent };